import api from "../axiosInstance";

export const getUsersAPI = async (payload) => {
  try {
    const { pageNumber, limit, sortBy, sortOrder, isBlocked, isVerified } = payload;
    let url = `/user/all/?page=${pageNumber}&limit=${limit}`;
    
    if (sortBy) {
      url += `&sortBy=${sortBy}`;
    }
    if (sortOrder) {
      url += `&sortOrder=${sortOrder}`;
    }
    if (isBlocked !== undefined && isBlocked !== null) {
      url += `&isBlocked=${isBlocked}`;
    }
    if (isVerified !== undefined && isVerified !== null) {
      url += `&isVerified=${isVerified}`;
    }
    
    const response = await api.get(url);
    return response;
  } catch (e) {
    console.log("Error getUsersAPI ", e);
  }
};

export const getUsersDeleteAPI = async (payload) => {
  try {
    const response = await api.delete(`/user/deleteUser/?userId=${payload}`);
    return response;
  } catch (e) {
    console.log("Error getUsersDeleteAPI ", e);
  }
};

export const getUsersBlockUnblockAPI = async (payload) => {
  try {
    const response = await api.put(`/user/block-unblock/?userId=${payload}`);
    return response;
  } catch (e) {
    console.log("Error getUsersDeleteAPI ", e);
  }
};

export const searchUsersAPI = async (payload) => {
  try {
    const { searchTerm, pageNumber, limit, sortBy, sortOrder, isBlocked, isVerified } = payload;
    let url = `/user/search?searchTerm=${encodeURIComponent(
      searchTerm || ""
    )}&page=${pageNumber}&limit=${limit}`;
    
    if (sortBy) {
      url += `&sortBy=${sortBy}`;
    }
    if (sortOrder) {
      url += `&sortOrder=${sortOrder}`;
    }
    if (isBlocked !== undefined && isBlocked !== null) {
      url += `&isBlocked=${isBlocked}`;
    }
    if (isVerified !== undefined && isVerified !== null) {
      url += `&isVerified=${isVerified}`;
    }
    
    const response = await api.get(url);
    return response;
  } catch (e) {
    console.log("Error searchUsersAPI ", e);
    throw e; // Re-throw the error so React Query can handle it
  }
};

// Update user profile by admin
export const updateUserByAdminAPI = async (userId, updateData) => {
  try {
    const response = await api.put(`/user/admin/${userId}`, updateData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Export users to CSV
export const exportUsersAPI = async () => {
  try {
    const response = await api.get("/admin/export-users", {
      responseType: "blob", // Important: Set responseType to blob for file download
    });
    return response;
  } catch (error) {
    // Handle blob error responses
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      let errorMessage = "Failed to export users";
      try {
        const errorData = JSON.parse(text);
        errorMessage = errorData.message || errorMessage;
      } catch (e) {
        // If parsing fails, use default message
      }
      error.response.data = { message: errorMessage };
    }
    console.log("Error exportUsersAPI ", error);
    throw error;
  }
};
